import React from 'react'
import { Box, Container, Typography, Hidden } from '@material-ui/core'
import { Image, Transformation } from 'cloudinary-react'
import { optimiseSizeForMobile, EXTRA_LARGE_SIZE, SMALLER_SIZE } from 'assets/CloudinaryURLHelper'
import { useStyles } from '../SchoolShow_style'
import { GetProgramTypeString } from '../SchoolShowHelper'
import IconFactory from 'shared/icons/IconFactory/IconFactory'
import RouteMap from 'assets/RouteMap.js'
import ShareAction from 'components/ShareAction/ShareAction'

const SchoolShowBanner = (props) => {
    const { school, topOfTabsRef } = props
    const classes = useStyles()

    return (<>
        {school.banner_image?.cloudinary_key &&
            <Box className={classes.bannerContainer}>
                <Box className={classes.shareButton}>
                    <ShareAction
                        infos={{
                            title: school.name,
                            url: RouteMap.Show('school', school.slug),
                            type: 'school'
                        }}
                    />
                </Box>
                <Image
                    alt={`${school.name} banner`}
                    cloudName="studentbe"
                    publicId={school.banner_image.cloudinary_key}
                >
                    <Transformation flags="progressive" fetchFormat="auto" width={optimiseSizeForMobile(EXTRA_LARGE_SIZE)} quality="auto:best" crop="fill" />
                </Image>
            </Box>
        }
        <Container maxWidth='lg'>
            <Box className={classes.schoolInfo}>
                {school.logo?.cloudinary_key &&
                    <Box className={classes.logoBox}>
                        <Box className={classes.logoCircle}>
                            <Image
                                className={classes.logo}
                                cloudName="studentbe"
                                publicId={school.logo.cloudinary_key ? school.logo.cloudinary_key : 'default-school-logo-black'}
                                alt={`${school.logo.cloudinary_key} logo`}
                            >
                                <Transformation flags="progressive" fetchFormat="auto" width={SMALLER_SIZE} quality="auto:best" crop="scale" />
                            </Image>
                        </Box>
                    </Box>
                }
                <Box className={classes.schoolInfoText}>
                    <Box className={classes.schoolNameAndCTA}>
                        <Typography component='h1' variant='h1' className={classes.schoolName}>
                            {school.name}
                        </Typography>
                    </Box>
                    <Box className={classes.schoolDetailsFlex} ref={topOfTabsRef}>
                        <Box className={classes.schoolDetails}>
                            <Hidden xsDown>
                                <IconFactory icon='attachment' fontSize='14px' />
                            </Hidden>
                            <Typography component='span'>{GetProgramTypeString(school.program_types)}</Typography>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Container>
    </>)
}

export default SchoolShowBanner
